import { render, staticRenderFns } from "./OrderedPayment.vue?vue&type=template&id=3fd2330c&scoped=true"
import script from "./OrderedPayment.vue?vue&type=script&lang=js"
export * from "./OrderedPayment.vue?vue&type=script&lang=js"
import style0 from "./OrderedPayment.vue?vue&type=style&index=0&id=3fd2330c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2330c",
  null
  
)

export default component.exports